import { USER_SETTINGS_API } from 'modules/profile/user-settings/hooks/use-user-settings'
import {
  EditableDataUserSettings,
  UseUserSettingsInterface,
} from 'modules/profile/user-settings/types/user-settings-interface'
import httpClient from 'shared/utils/http-client'

export const updateUserSettings = (data: EditableDataUserSettings) =>
  httpClient.patch<UseUserSettingsInterface>(USER_SETTINGS_API, data)
